"use client"

import { GetPageByRouteQuery } from "apollo"
import { Suspense } from "react"
import { getBreadCrumbs, transformProperties } from "utils"
import DynamicTitle from "../Common/DynamicTitle"
import Hero from "../Common/Hero"
import JobDisplay from "./JobDisplay"
import MultyUrl from "./MultyUrl"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  recomndationData: any
  jobResponse: any
}

export default function HeadquarterCareer({
  data,
  locale,
  recomndationData,
  jobResponse,
}: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  const heroData = blocks?.blocks?.find(
    (block: any) => block.blockType === "heroBanner",
  )
  const adynamicTitleAndContant = blocks?.blocks?.find(
    (block: any) => block.blockType === "adynamicTitleAndContant",
  )
  const MultyURLsTitleAndText = blocks?.blocks?.find(
    (block: any) => block.blockType === "MultyURLsTitleAndText",
  )
  return (
    <>
      <Hero data={heroData} breadCrumbs={breadCrumbs} />
      <DynamicTitle data={adynamicTitleAndContant} />
      <Suspense>
        <JobDisplay jobResponse={jobResponse} />
      </Suspense>
      {/* <Recomendations data={recomndationData} /> */}
      <MultyUrl data={MultyURLsTitleAndText} />
    </>
  )
}
